export interface Paginated<T> {
  data: T[];
  total: number;
  limit: number;
  offset: number;
}

type Envelope = Record<string, unknown> & { version?: unknown; _links?: unknown };

export function unwrapObject<T>(body: unknown): T {
  if (!body || typeof body !== 'object' || Array.isArray(body)) return body as T;
  const { version: _version, _links: _links, ...payload } = body as Envelope;
  return payload as T;
}

export function unwrapArray<T>(body: unknown): T[] {
  if (Array.isArray(body)) return body as T[];
  const data = (body as Envelope | null)?.data;
  return Array.isArray(data) ? (data as T[]) : [];
}

export function unwrapPaginated<T>(body: unknown): Paginated<T> {
  if (Array.isArray(body)) {
    return { data: body as T[], total: body.length, limit: body.length, offset: 0 };
  }

  const envelope = (body ?? {}) as Envelope;
  const data = Array.isArray(envelope.data) ? (envelope.data as T[]) : [];
  return {
    data,
    total: typeof envelope.total === 'number' ? envelope.total : data.length,
    limit: typeof envelope.limit === 'number' ? envelope.limit : data.length,
    offset: typeof envelope.offset === 'number' ? envelope.offset : 0,
  };
}
